import React, { useEffect, useState } from "react";
import { useParams, Redirect } from "react-router-dom";
import { getUserByUsernameAPI } from "../api/userApi";
import BaseLoading from "./Loader/BaseLoading";
import { validateUsernameFormat } from "../utils/usernameValidation";
import { UserInterface } from "../types/user";
import { useAppSelector } from "../redux/typedHooks";

interface ProfileRedirectProps {
  children: React.ReactNode;
}

const ProfileRedirect: React.FC<ProfileRedirectProps> = ({ children }) => {
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectTo, setRedirectTo] = useState<string>("");
  const userData = useAppSelector<UserInterface | null>(
    state => state.user.currentUser
  );

  useEffect(() => {
    const checkAndRedirect = async () => {
      try {
        // Check if the ID is a username (not a MongoDB ObjectId)
        const isObjectId = /^[0-9a-fA-F]{24}$/.test(id);

        if (!isObjectId) {
          // Validate username format first
          const formatValidation = validateUsernameFormat(id);
          if (!formatValidation.isValid) {
            console.error("Invalid username format:", formatValidation.error);
            setIsLoading(false);
            return;
          }

          // It's a username, try to find the user
          // const user = await getUserByUsernameAPI(
          //   id !== "settings" ? id : userData?.username
          // );
          // if (user && user._id) {
          //   // Check if the username in URL matches current username
          //   if (user.username === id) {
          //     // Username is current, proceed normally
          //     setIsLoading(false);
          //     return;
          //   } else {
          //     // Username has changed, redirect to current username
          //     setRedirectTo(`/${user.username}`);
          //     setShouldRedirect(true);
          //     return;
          //   }
          // }
        }

        // If it's already an ObjectId or user not found, proceed normally
        setIsLoading(false);
      } catch (error) {
        console.error("Error checking user redirect:", error);
        setIsLoading(false);
      }
    };

    checkAndRedirect();
  }, [id, userData]);

  if (isLoading) {
    return <BaseLoading title="Loading profile..." />;
  }

  if (shouldRedirect && redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return <>{children}</>;
};

export default ProfileRedirect;
